var React = require('react');

function PlayBtn (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},[React.createElement("circle",{"cx":"80","cy":"80","fill":"#fff","fillOpacity":".639368","r":"80","key":0}),React.createElement("path",{"d":"m90.4744055 57.6501451 29.9638455 42.4672769c1.592004 2.256322 1.053468 5.376005-1.202853 6.968009-.84342.595096-1.85035.914569-2.882578.914569h-61.4258832c-2.7614237 0-5-2.238576-5-5 0-1.071796.3444055-2.115227.982431-2.976431l31.4620378-42.4672769c1.6438372-2.2188421 4.7751575-2.6849756 6.9939996-1.0411383.427728.3168838.8021085.7000385 1.1090003 1.1349913z","fill":"#b83a5f","transform":"matrix(0 1 -1 0 165.5 -5.5)","key":1})]));
}

PlayBtn.defaultProps = {"height":"160","viewBox":"0 0 160 160","width":"160"};

module.exports = PlayBtn;

PlayBtn.default = PlayBtn;
